export class DynamicEpisodesModel {
    constructor(episodesData) {
        this.episodesData = episodesData;
    }

    get episodes() {
        return {
             ...this.episodesData?.value?.podcast,
            episodes: this.episodesData?.value?.episodes.map(item => {
                return {
                    ...item,
                    episodeTitle: item.name,
                    episodeSrc: item.audio_url,
                    episodeDescription: item.description,
                    episodeEmbedId: item.embed_id,
                    podcastImageUrl: item?.podcastImageUrl,
                    podcastTitle: item?.podcastTitle,
                }
            })
        }
    }z
}
